import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes, {
  bool,
  func,
  shape,
  string,
  arrayOf
} from 'prop-types';
import { Rating } from '@thd-olt-component-react/rating';
import { Image } from '@thd-olt-component-react/image';
import { Price } from '@thd-olt-component-react/price';
import * as analytics from '../../analytics/frequentlyboughttogether-analytics';
import { AlternateOptions } from './AlternateOptions';
import './BundleItem.style.scss';

const BundleItem = ({
  anchor,
  anchorProduct,
  itemInCart,
  checked,
  openInNewTab,
  product,
  onAdd,
  onRemove
}) => {

  if (!product) return null;

  const handleAction = useCallback((evt) => {
    evt.preventDefault();
    if (checked && onRemove) {
      onRemove(product.identifiers.itemId);
    }
    if (!checked && onAdd) {
      onAdd(product.identifiers.itemId);
    }
  }, [product.identifiers.itemId, checked]);

  const {
    identifiers, info, media, pricing, reviews
  } = product;
  const { brandName, canonicalUrl, productLabel, itemId } = identifiers || {};
  const { url } = media?.image || {};
  const imageUrl = url.replace('<SIZE>', 300);
  const { ratingsReviews: { averageRating, totalReviews } } = reviews || {};

  return (
    <div className="bundle-item">
      <a
        className="bundle-item--generic"
        href={canonicalUrl}
        onClick={() => analytics.track({
          itemId: anchorProduct.itemId,
          bundle: true
        })}
        rel={openInNewTab ? 'noopener noreferrer' : ''}
        target={openInNewTab ? '_blank' : '_self'}
      >
        <div className="bundle-item__image">
          <Image src={imageUrl} alt={brandName} stretchy />
        </div>
        <div className="bundle-item__wrapper">
          <div className="bundle-item__product-details">
            {anchor && <div className="bundle-item__item-state">(Current Item)</div>}
            {itemInCart && (
              <div className="bundle-item__item-in-cart">
                <img
                  src="https://assets.homedepot-static.com/images/v1/alert-check-green.svg"
                  alt="Check"
                  loading="lazy"
                />
                <span>In Your Cart</span>
              </div>
            )}
            <div className="bundle-item__label">{productLabel}</div>
            <div className="bundle-item__brand-name">by <span className="u__bold">{brandName}</span></div>
            <div className="bundle-item__ratings-reviews">
              <Rating value={parseFloat(averageRating)} />
              <span>({Number(totalReviews)})</span>
            </div>
            <div className="bundle-item__price">
              <Price itemId={itemId} large={false} product={product} disableRangePricing hideBadge />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

BundleItem.propTypes = {
  anchor: bool,
  anchorProduct: shape({}).isRequired,
  checked: bool.isRequired,
  itemInCart: bool,
  openInNewTab: bool.isRequired,
  product: shape({}).isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func
};

BundleItem.defaultProps = {
  anchor: false,
  onAdd: null,
  onRemove: null,
  itemInCart: false
};

BundleItem.displayName = 'FBTBundleItem';

export default BundleItem;
